import { scrollRunwayCss } from '@/lib/scroll-runway';

export const defaultTitle = 'How injury <br/> <i>cases work</i>';

/**
 * Measured height of the desktop sticky card at the 1440px page max-width.
 *
 * The carousel reserves a scroll runway of `card height * (steps - 1) + one viewport`, and
 * `useVerticalScrollCarousel` recomputes it from the real `offsetHeight` once mounted. The
 * server render has to reserve the same amount up front, otherwise the page grows by
 * thousands of pixels the moment the section mounts and everything below it — including the
 * footer form — moves out from under the reader. See JLG4-239.
 */
export const DESKTOP_STICKY_CARD_HEIGHT = 995;

export function desktopScrollRunway(stepCount: number): string {
  return scrollRunwayCss(`${DESKTOP_STICKY_CARD_HEIGHT}px`, Math.max(0, stepCount - 1));
}

/**
 * The mobile sticky container is `h-screen`, so its card height *is* the viewport height and
 * the runway is exact — no measured constant needed.
 */
export function mobileScrollRunway(stepCount: number): string {
  return scrollRunwayCss('100vh', Math.max(0, stepCount - 1));
}
